import React from "react";

const STEPS = ["Account", "Verify email", "Access"];

export default function RegistrationStepper({ activeStep = 0 }) {
  return (
    <ol className="pa-stepper" aria-label="Registration progress">
      {STEPS.map((step, index) => (
        <li key={step} className={index === activeStep ? "is-current" : index < activeStep ? "is-complete" : ""}>
          <span>{index < activeStep ? "✓" : index + 1}</span>
          {step}
        </li>
      ))}
    </ol>
  );
}

